<template>
    <div class="pagination-wrapper">
        <div class="pagination-text">
            <p>Page <span class="pagination-text__current">{{ page }}</span> of {{ pageCount || 1 }}</p>
        </div>
        <div class="pagination-links">
            <a @click.prevent="$emit('pageController', page > 1 ? page - 1 : page)" class="pagination-link pagination-link--prev">
                <svg width="1em" height="1em" class="icon icon-chevron ">
                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                </svg>
            </a>
            <a href="javascript:void(0)" class="pagination-link" 
                v-for="(item, index) in Array(3).fill(true)" 
                :key="index + 10"
                v-if="(page - 3 + index) < page && (page - 3 + index) > 0 && pageCount - page < 3"
                @click.prevent="$emit('pageController', page - 3 + index)"
                >{{ page - 3 + index }}</a>
            <a class="pagination-link pagination-link--current">{{ page }}</a>
            <a class="pagination-link" 
                v-for="(item, index) in Array(3).fill(true)" 
                :key="index"
                v-if="(index + 1 + page) <= pageCount"
                @click.prevent="$emit('pageController', page + index + 1)"
                >{{ page + index + 1 }}</a>
            <a @click.prevent="$emit('pageController', page < pageCount ? page + 1 : page)" class="pagination-link pagination-link--next">
                <svg width="1em" height="1em" class="icon icon-chevron ">
                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                </svg>
            </a>
        </div>
    </div>
</template>

<script>

    export default {
        props: ['page', 'pageCount'],
    }
</script>